module.exports = __webpack_public_path__ + "assets/classic_ball.e4666da1.svg";